module.exports = __webpack_public_path__ + "img/video2.d7ba2320.jpg";